import { changePassword } from "./auth/change-password.js";
import { login } from "./auth/login.js";
import { requestPasswordReset } from "./auth/request-password-reset.js";
import { resetPassword } from "./auth/reset-password.js";
import { getTenantBranding } from "./branding/get-tenant-branding.js";
import { updateBranding } from "./branding/update-branding.js";
import { uploadTenantAsset } from "./branding/upload-tenant-asset.js";
import { getTenantPaymentCredentials, updateTenantPaymentCredentials, deleteTenantPaymentCredentials, } from "./payment-credentials/index.js";
import { createTenant } from "./tenant/create-tenant.js";
import { deleteTenant } from "./tenant/delete-tenant.js";
import { getTenant } from "./tenant/get-tenant.js";
import { listTenants } from "./tenant/list-tenants.js";
import { reactivateTenant } from "./tenant/reactivate-tenant.js";
import { suspendTenant } from "./tenant/suspend-tenant.js";
import { updateTenant } from "./tenant/update-tenant.js";
export const httpUseCasesAdmin = [
    createTenant,
    listTenants,
    getTenant,
    updateTenant,
    suspendTenant,
    reactivateTenant,
    deleteTenant,
    getTenantBranding,
    updateBranding,
    uploadTenantAsset,
    getTenantPaymentCredentials,
    updateTenantPaymentCredentials,
    deleteTenantPaymentCredentials,
    changePassword,
    login,
    requestPasswordReset,
    resetPassword,
];
